export const LOCAL_FILES_NAMESPACE = "03379cf5-4675-40ec-b44c-9501f39493b1";
